export default {
  appraisalDetail: {
    component: () =>
      import(
        /* webpackChunkName: "archive_detail" */ "@/mods/archive/participationAppraisal/detailView/AppraisalDetail"
      ),
  },
};
